import { ELanguage } from '@microfrontends/react-components'
import MainLayout from '../../containers/MainLayout'
import { ETypeNumerologyPage } from '../../services/models'
import { getServerSideProps } from '../../ssr/careerNewbie'
import CareerNewbieLandingPage from '../../components/CareerNewbie/Landing'
import { customTranslation } from '../../helpers/translation'
import { EPages } from '@microfrontends/app-shell-v2'
export function CareerNewbiesPage(props) {
	const { isRobot = false, data } = props
	return (
		<MainLayout
			{...props}
			metaCanonical='lo-trinh-su-nghiep'
			languageCode={ELanguage.VI}
			t={customTranslation('careerNewbie', ELanguage.VI)}
			numerologyPage={ETypeNumerologyPage.HomeCareerPath}
			pageName={EPages.CAREER_NEWBIES}
			metaTitle='Career Newbies | VietnamWorks'
			metaDescription='Hệ sinh thái sự nghiệp và cơ hội việc làm dành cho các bạn đang là sinh viên/thực tập sinh và mới tốt nghiệp trên VietnamWorks'
			noIndex
		>
			<CareerNewbieLandingPage isRobot={isRobot} {...data} />
		</MainLayout>
	)
}

export default CareerNewbiesPage

export { getServerSideProps }
